import React, { useState } from 'react';
import { func, string } from 'prop-types';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { IconButton, styled } from '@mui/material';

const Copy = styled('div', {
  shouldForwardProp: prop => prop !== 'padding',
})(({ padding }) => ({
  display: 'flex',

  button: {
    ...(padding && {
      padding,
    }),
  },
}));

const CopyButton = ({ content, onClick, padding }) => {
  const [showCopied, setShowCopied] = useState(false);

  const handleCopyClick = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(content);
    if (onClick) {
      onClick();
    }
    setShowCopied(true);
    setTimeout(() => {
      setShowCopied(false);
    }, 2000);
  };

  return (
    <Copy padding={padding}>
      <IconButton onClick={handleCopyClick} aria-label="copy" name="copy">
        {showCopied ? (
          <CheckRoundedIcon />
        ) : (
          <ContentCopyRoundedIcon />
        )}
      </IconButton>
    </Copy>
  );
};

export default CopyButton;

CopyButton.propTypes = {
  content: string.isRequired,
  onClick: func,
  padding: string,
};

CopyButton.defaultProps = {
  onClick: undefined,
  padding: undefined,
};
